import { BACKEND_URL } from "../../../../constants";
import { ALL_GENES } from '../../../../constants';

const URL = `${BACKEND_URL}/graphql`;


const QUERY = `
query (
  $accessions: [String]!,
  $first: Int!,
  $include: Boolean!,
  $regions: [String]!,
  $rFirst: Int!,
  $rInclude: Boolean!,
  $sources: [String]!,
  $sFirst: Int!,
  $sInclude: Boolean!,
  $ldInclude: Boolean!
){
  viewer {
    sequences(first: $first, accessions: $accessions) @include(if: $include) {
      edges {
        node {
          accession
          cloneName
          isolate {
            isolateName
            isolateDate
            dateMatch
            isolateType
            host
            species
            gene
            authorSubtype
            clinicalIsolate {
              source culture seqTemplate cloneMethod
            }
            patient {
              id
              pseudoName
              region
              isChild
            }
          }
        }
      }
    }
    luBodySources(sources: $sources, first: $sFirst) @include(if: $sInclude) {
      edges {
        node {
          source
        }
      }
    }
    BodySourceList: luBodySources(first: 100) @include(if: $ldInclude) {
      edges {
        node {
          source
        }
      }
    }
    luCountries(regions: $regions, first: $rFirst) @include(if: $rInclude) {
      edges {
        node {
          region
        }
      }
    }
    CountryList: luCountries(first: 200) @include(if: $ldInclude) {
      edges {
        node {
          region
        }
      }
    }
    lazy
  }
}
`;

export default async function API({
  accessions,
  regions,
  sources,
  ldInclude}) {

  accessions = accessions || [];
  regions = regions || [];
  sources = sources || [];
  ldInclude = ldInclude || false;

  const first = accessions.length * ALL_GENES.length;
  const include = accessions.length > 0;


  const rFirst = regions.length;
  const rInclude = regions.length > 0;
  const sFirst = sources.length;
  const sInclude = sources.length > 0;


  const request = new Request(
    URL,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          accessions: accessions,
          first: first,
          include: include,
          regions: regions,
          rFirst: rFirst,
          rInclude: rInclude,
          sources: sources,
          sFirst: sFirst,
          sInclude: sInclude,
          ldInclude: ldInclude,
        }
      })
    });

  const resp = await fetch(request);
  const {data} =  await resp.json();

  return data;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/hivdb/api.js